import React from 'react'

function Favorites() {
  return (
    <div>
      
    </div>
  )
}

export default Favorites
